import { observer } from "mobx-react-lite";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
} from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../app/layout/PageHeader";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import ReportsDropdownMenu from "./ReportsDropdownMenu";
import ReactToPrint from "react-to-print";
import InventoryCountSheetPrint from "./pdf/InventoryCountSheetPrint";

export default observer(function InventoryCountSheet() {
  const { t } = useTranslation(["common", "reports"]);
  const componentRef = useRef<HTMLDivElement | null>(null);

  const { inventoryPhysicalCountReportStore } = useStore();
  const {
    groupedInventoryPhysicalCountReport,
    loadingInitial,
    loadPhysicalCountReport,
    reportCriteria,
  } = inventoryPhysicalCountReportStore;

  const [submitCounter, setSubmitCounter] = useState<number>(0);

  useEffect(
    () => {
      if(submitCounter)
        loadPhysicalCountReport();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [submitCounter]
  )

  if (loadingInitial)
    return (
      <LoadingComponent content={t("inventory.physicalCount_loading", { ns: "reports" })} />
    );

  return (
    <>
      <Grid stackable columns={2}>
        <Grid.Column>
          <PageHeader
            header={`${t("report", { ns: "reports" })}: ${t("physical_count_sheet", {
              ns: "reports",
            })}`}
            type="h2"
            divider={false}
            getAlerts={true}
            addTitle={true}
          />
        </Grid.Column>
        <Grid.Column textAlign="right">
          <ReportsDropdownMenu />
        </Grid.Column>
      </Grid>
      <Divider />
      <Container>
          <>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Button
                    color="green"
                    className="save_button"
                    icon="check"
                    content={ t("get_report", { ns: "reports" })}
                    type="button"
                    onClick={() => setSubmitCounter(submitCounter + 1) }
                    data-testid="save"
                    />
                </Grid.Column>
                <Grid.Column>
                  {groupedInventoryPhysicalCountReport && groupedInventoryPhysicalCountReport.length > 0 && (
                    <ReactToPrint
                      trigger={() => (
                        <Button floated="right" icon="print" type="button">
                          {t("estimate.print", { ns: "tickets" })}
                        </Button>
                      )}
                      content={() => componentRef.current}
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          {groupedInventoryPhysicalCountReport && groupedInventoryPhysicalCountReport.length > 0 && (
            <div ref={componentRef} className="printMargins">
              <InventoryCountSheetPrint
                startDate={reportCriteria.startDate ?? new Date()}
                endDate={reportCriteria.endDate ?? new Date()}
              />
            </div>
          )}
          </>
      </Container>
    </>
  );
});
